
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
const Chart = require("chart.js");

@Component
export default class PlatformChart extends Vue {
	@Prop()
	private campaigns!: [];
	@Prop()
	private valueToShow!: string; // "Klicks" or "Registrierungen"
	@Prop()
	private reloadToggle!: boolean;
	private chart: any = null;
	// 19 colors for chart lines
	private colors = [
		"#E53935",
		"#D81B60",
		"#8E24AA",
		"#5E35B1",
		"#3949AB",
		"#1E88E5",
		"#039BE5",
		"#00ACC1",
		"#00897B",
		"#43A047",
		"#7CB342",
		"#C0CA33",
		"#FDD835",
		"#FFB300",
		"#FB8C00",
		"#F4511E",
		"#6D4C41",
		"#757575",
		"#546E7A",
	];

	private mounted() {
		this.updateDiagram();
	}

	@Watch("valueToShow")
	private reload() {
		this.updateDiagram();
	}
	@Watch("reloadToggle")
	private reloadByToggle() {
		console.log("reloading chart");
		this.updateDiagram();
	}

	private updateDiagram() {
		const { labels, datasets } = this.getDatasets();

		// Destroy the chart if one already exists.
		if (this.chart != null) {
			this.chart.destroy();
		}

		const ctx = (this.$refs.diagramCanvas as any).getContext("2d");
		this.chart = new Chart(ctx, {
			// The type of chart we want to create
			type: "line",
			// The data for our dataset
			data: {
				labels,
				datasets,
			},
			// Configuration options go here
			options: {
				responsive: true,
				scales: {
					yAxes: [
						{
							ticks: {
								precision: 0,
								min: 0,
							},
						},
					],
				},
				tooltips: {
					callbacks: {
						label: function (tooltipItem: any, data: any): any {
							var value = tooltipItem.yLabel;
							var campaignName = data.datasets[tooltipItem.datasetIndex].label;
							return `${value} | Kampagne: ${campaignName}`;
						},
					},
				},
			},
		});

		this.chart.update();
	}

	private getDatasets(): { labels: any; datasets: any } {
		if (!this.campaigns) return { labels: [], datasets: [] };
		const allDates = Array.from(
			new Set(this.campaigns.flatMap((c: any) => c.dailyActivities.map((a: any) => a.date)))
		)
			.sort()
			.map((date: Date) => moment(date).format("DD.MM.YYYY"));

		const datasets = this.campaigns.map((c: any, index) => {
			let clicksByDate: any;
			if (this.valueToShow == "Klicks") {
				clicksByDate = new Map(
					c.dailyActivities.map((a: any) => [
						moment(a.date).format("DD.MM.YYYY"),
						a.clicks,
					])
				);
			} else {
				clicksByDate = new Map(
					c.dailyActivities.map((a: any) => [
						moment(a.date).format("DD.MM.YYYY"),
						a.registrations,
					])
				);
			}
			let data: number | unknown = allDates.map((date: any) => clicksByDate.get(date));
			if (!data) {
				data = 0;
			}

			return {
				label: c.campaignDescription,
				data: data,
				borderColor: this.colors[index % 19],
				borderWidth: 2,
				pointHitRadius: 2, // Size of the area where the point reacts to the mouse
				fill: false,
				tension: 0.3, // How "smooth" the line is. 0 for straight lines
			};
		});

		return { labels: allDates, datasets };
	}
}
